<template>
  <div class="relative w-full rounded-md border shadow-sm" :class="cGroupClass">
    <input
      v-model="localModelValue"
      type="text"
      name="account-number"
      class="block w-full rounded-md border-0 bg-white px-3 py-2 text-gray-900 placeholder-gray-500 focus:ring-0 sm:text-sm dark:bg-slate-500 dark:text-white"
      :placeholder="cPlaceholder"
      :maxlength="maxlength"
    />
    <div
      class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
    >
      <FontAwesomeIcon :icon="['fal', 'search']" />
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'BaseSimpleSearchInput',
  components: { FontAwesomeIcon },
  props: {
    groupClass: {
      type: String,
      required: false,
      default: ''
    },
    modelValue: {
      type: String,
      required: true
    },
    size: {
      type: String,
      required: false,
      default: 'md'
    },
    placeholder: {
      type: String,
      required: false,
      default: null
    },
    maxlength: {
      type: Number,
      required: false,
      default: null
    }
  },
  emits: ['update:modelValue'],
  computed: {
    localModelValue: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    },
    cGroupClass() {
      return this.groupClass === '' ? 'mt-1' : this.groupClass
    },
    cPlaceholder() {
      if (!this.placeholder) return this.$t('global.placeholder.search')
      return this.placeholder
    }
  }
}
</script>
